import type { RouteRecordRaw } from 'vue-router'

import {
  routeActivityRadarHome,
  routeActivityRadarRoot,
} from '@/routers/routes/mainRoutes/routeActivities/activitiesRoutes.ts'
import { routeCalendarRoot } from '@/routers/routes/mainRoutes/routeActivities/calendarRoutes.ts'
import { routeTodosRoot } from '@/routers/routes/mainRoutes/routeActivities/todoRoutes.ts'

import { routeInboxRoot, routeOutboxRoot } from './communicationRoutes'

const routeActivitiesHome: RouteRecordRaw = {
  name: 'activities-home',
  path: '',
  redirect: routeActivityRadarHome,
}

const routeActivitiesRoot: RouteRecordRaw = {
  children: [
    routeActivitiesHome,
    routeActivityRadarRoot,
    routeTodosRoot,
    routeInboxRoot,
    routeOutboxRoot,
    routeCalendarRoot,
  ],
  path: 'activities',
}

export { routeActivitiesHome, routeActivitiesRoot }
